import React from "react";
import wp1 from "../assets/privacypolicy.webp";

const PrivacyPolicy: React.FC = () => {
  const sections = [
    {
      title: "1. Information Collection",
      content: (
        <>
          <p className="mb-2">
            We collect essential information to provide our services efficiently:
          </p>
          <ul className="list-disc list-inside space-y-1 text-gray-700">
            <li>Personal Details: Name, Email, Phone, Address</li>
            <li>Project Details: Floor plans, photos, design preferences</li>
            <li>Technical Data: Cookies, IP addresses for website performance</li>
          </ul>
        </>
      ),
    },
    {
      title: "2. Use of Information",
      content: (
        <>
          <p className="mb-2">Your data helps us serve you better:</p>
          <ul className="list-disc list-inside space-y-1 text-gray-700">
            <li>Plan and execute interior design projects</li>
            <li>Send updates, quotations, and notifications</li>
            <li>Provide prompt customer support</li>
            <li>Protect data and avoid unauthorized sharing</li>
          </ul>
        </>
      ),
    },
    {
      title: "3. Data Security",
      content: (
        <p className="text-gray-700">
          We employ state-of-the-art security measures to protect your personal information from unauthorized access, misuse, or disclosure.
        </p>
      ),
    },
    {
      title: "4. Cookies & Tracking",
      content: (
        <p className="text-gray-700">
          We use cookies to enhance your browsing experience and analyze website traffic. You can manage cookies via your browser settings.
        </p>
      ),
    },
    {
      title: "5. Contact Us",
      content: (
        <p className="text-gray-700">
          For privacy-related concerns, reach out to us:
          <br />
          <span className="font-medium text-amber-500 mt-1 block">
            Email: hello@luxuriyahomes.com<br />
            Phone: +91 7291832000
          </span>
        </p>
      ),
    },
  ];

  return (
    <div className="bg-gray-50 min-h-screen text-gray-800">

      {/* ================= HERO ================= */}
      <section
        className="relative h-[55vh] flex items-center justify-center text-center bg-cover bg-center"
        style={{ backgroundImage: `url(${wp1})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/20"></div>
        <div className="relative z-10 max-w-3xl px-6">
          <h1 className="text-5xl md:text-6xl font-serif font-bold text-amber-400 mb-4 drop-shadow-lg">
            Privacy Policy
          </h1>
          <p className="text-gray-100 text-base md:text-lg drop-shadow">
            Your privacy is our top priority. We handle your data with utmost care and security.
          </p>
        </div>
      </section>

      {/* ================= CONTENT ================= */}
      <section className="max-w-5xl mx-auto px-6 py-20 space-y-16 ">
        {sections.map((section, idx) => (
          <div
            key={idx}
            className="relative bg-white rounded-[2rem] p-12 shadow-2xl hover:shadow-3xl transition-shadow duration-500"
          >
            {/* Elegant accent line */}
            <div className="absolute -top-6 left-0 w-20 h-1 bg-gradient-to-r from-amber-400 to-amber-200 rounded-full"></div>
            
            <h2 className="text-3xl font-bold text-gray-800 mb-6">{section.title}</h2>
            <div className="text-gray-700 text-lg leading-relaxed">{section.content}</div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default PrivacyPolicy;
